import { render, staticRenderFns } from "./show-history.vue?vue&type=template&id=3880ccba&scoped=true&"
import script from "./show-history.vue?vue&type=script&lang=js&"
export * from "./show-history.vue?vue&type=script&lang=js&"
import style0 from "./show-history.vue?vue&type=style&index=0&id=3880ccba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3880ccba",
  null
  
)

export default component.exports